import type { DuracaoInput } from '../types/negociacaoMarcoTypes';

const MS_POR_DIA = 24 * 60 * 60 * 1000;

function paraData(valor: string | null | undefined): Date | null {
  if (!valor) return null;
  const data = new Date(valor);
  return Number.isNaN(data.getTime()) ? null : data;
}

function pluralDias(dias: number): string {
  return dias === 1 ? '1 dia' : `${dias} dias`;
}

export function duracaoNegociacao({
  dataCriacao,
  dataEncerramento,
  agora = new Date(),
}: DuracaoInput): string | null {
  const inicio = paraData(dataCriacao);
  if (!inicio) return null;

  const fim = paraData(dataEncerramento);
  const referencia = fim ?? agora;
  const dias = Math.max(0, Math.floor((referencia.getTime() - inicio.getTime()) / MS_POR_DIA));

  return fim ? `Fechado em ${pluralDias(dias)}` : `Em aberto há ${pluralDias(dias)}`;
}
